import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { ConfluenceConnector } from '../../connector';

export const ConfluenceService = IntegrationService.make({
  connector: ConfluenceConnector,
  name: Integration_Service_Names_Enum.Confluence,
});
